import React from 'react';

import styles from './cookieBannerContent.scss';

interface CookieBannerContentProps {
  children: React.ReactNode;
}

function CookieBannerContent(props: CookieBannerContentProps) {
  return <div className={styles.wrapper}>{props.children}</div>;
}

export default CookieBannerContent;
